export default "__VITE_ASSET__0rL6SvH5__"